import React from "react";
import "./privacyPolicy.css";
function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <div className="content">
        <h2>Privacy Policy</h2>
        <p>
          Techvanto Pvt. Ltd. having its registered address at MIG Flat No. 600,
          T/F, Sarvahit Apartments, Pkt - A, Sector -17, Dwarka Ph -II New Delhi
          - 110075 and having an office situated at R-7, Main Mehrauli-Gurgaon
          Rd, Ghitorni, New Delhi, Delhi - 110030. At Techvanto Academy,
          accessible from https://techvantoacademy.com/, one of our main
          priorities is the privacy of our visitors. This Privacy Policy
          document contains types of information that is collected and recorded
          by Techvanto Academy and how we use it. If you have additional
          questions or require more information about our Privacy Policy, do not
          hesitate to contact us at info@techvanto.com. Note: Our Company’s
          privacy policies can be updated at any point in time without any prior
          notice to the users. To keep yourself always updates with the updated
          and revised policies, please keep checking the policies regularly
          through the Techvanto applications, desktop websites and mobile WAP
          pages.
          <br />
          <br />
          <h3>Consent</h3>
          By installing and using the Techvanto application / Website / WAP
          platform, you specifically agree to the use and disclosure of your
          personal information in compliance with this Privacy Policy. If you do
          not agree with the terms of the policy, please do not use or access
          the Techvanto application/Website / WAP platform.
        </p>
        <p>
          <br />
          <h3>Information we collect</h3>
          The personal information that you are asked to provide, and the
          reasons why you are asked to provide it, will be made clear to you at
          the point we ask you to provide your personal information. If you
          contact us directly, we may receive additional information about you
          such as your name, email address, phone number, the contents of the
          message and/or attachments you may send us, and any other information
          you may choose to provide.
          <br />
          When you register for an Account, we may ask for your contact
          information, including items such as name, college/occupation,
          address, email address, and telephone number.
        </p>
        <p>
          <br />
          <h3>How we use your information</h3>
          The personal details of the users which we collect from the backend is
          collected by us to provide you with the services and goods that you
          have expressly ordered, to settle conflicts, to resolve disputes, to
          help facilitate secure services, to raise revenue, to calculate
          customer interest in our services, to remind you of deals, products,
          services, changes, to tailor your experience, to monitor and defend us
          from mistake, theft and other illegal behaviour, to enforce our terms
          and conditions, etc.
          <br />
          We use the information we collect in various ways, including to:
          <br />
          <ul>
            <li>Provide, operate, and maintain our website</li>
            <li>Improve, personalize, and expand our website</li>
            <li>Understand and analyze how you use our website</li>
            <li>Develop new products, services, features, and functionality</li>
            <li>
              Communicate with you, either directly or through one of our
              partners, including for customer service, to provide you with
              updates and other information relating to the website, and for
              marketing and promotional purposes
            </li>
            <li>Send you emails</li>
            <li>Find and prevent fraud</li>
          </ul>
          Occasionally, we invite our users to complete an optional online
          survey. These surveys can ask for contact details and demographic
          information (such as zip code, age, gender, etc.). The main aim of
          these online surveys is to modify your experience at Techvanto Pvt.
          Ltd., to update you with content that we think you would be interested
          in, and to view content according to your preferences and choice as
          well.
        </p>
        <p>
          <br />
          <h3>Log Files</h3>
          Techvanto Academy follows a standard procedure of using log files.
          These files log visitors when they visit websites. All hosting
          companies do this and this is a part of hosting services' analytics.
          The information collected by log files include internet protocol (IP)
          addresses, browser type, Internet Service Provider (ISP), date and
          time stamp, referring/exit pages, and possibly the number of clicks.
          These are not linked to any information that is personally
          identifiable. The purpose of the information is for analyzing trends,
          administering the site, tracking users' movement on the website, and
          gathering demographic information.
        </p>
        <p>
          <br />
          <h3>Cookies and Web Beacons</h3>Like any other website, Techvanto
          Academy uses 'cookies'. These cookies are used to store information
          including visitors' preferences, and the pages on the website that the
          visitor accessed or visited. The information is used to optimize the
          users' experience by customizing our web page content based on
          visitors' browser type and/or other information. However, if you have
          already submitted publicly identifying information to the website,
          cookies may be connected to that information that you provided. The
          aggregate of cookies and monitored information can be shared with
          third parties.
          <br />
          You can choose to disable cookies through your individual browser
          options. To know more detailed information about cookie management
          with specific web browsers, it can be found at the browsers'
          respective websites.
        </p>
        <p>
          <br />
          <h3>Links to Other Sites</h3>
          Our website may connect to other websites that may collect personally
          identifiable information about you which is provided by you. Techvanto
          does not take the responsibility for the privacy policies or content
          of those other related websites.
          <br />
          Note that Techvanto Academy has no access to or control over these
          cookies that are used by third-party advertisers. Techvanto Academy's
          Privacy Policy does not apply to other advertisers or websites. Thus,
          we are advising you to consult the respective Privacy Policies of
          these third-party ad servers for more detailed information. It may
          include their practices and instructions about how to opt out of
          certain options.
        </p>
        <p>
          <br />
          <h3>Security</h3>
          Techvanto Academy respects your privacy and uses reasonable efforts to
          protect the same. We have adequate safeguards and infrastructure to
          comply with Information Technology Act, 2000 and all other applicable
          data protection laws in India to protect your privacy.
          <br />
          By providing your information to Techvanto Pvt. Ltd. in accordance
          with this Privacy Policy you agree to process and use the information,
          including, but not limited to, your approval for the divulgation of
          your information under the Privacy Policy in Techvanto. Ltd.
        </p>
        <p>
          By providing your information to Techvanto Pvt. Ltd. In accordance
          with this Privacy Policy you agree to process and use the information,
          including, but not limited to, your approval for the divulgation of
          your information under the Privacy Policy in Techvanto. Ltd. You
          agree.
        </p>
        <p>
          <br />
          <h3>Children's Information</h3>
          Techvanto Academy does not knowingly collect any Personal Identifiable
          Information from children under the age of 13. Another part of our
          priority is adding protection for children while using the internet.
          We encourage parents and guardians to observe, participate in, and/or
          monitor and guide their online activity.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
